<ng-container *ngIf="loaded && subscriptionSummary; else loading">



  <div fxFlex="70" class="container subscription-active-banner"
    style="margin-bottom:12px;padding:12px;border:1px solid #e0e0e0;border-radius:6px;background:#f8fafc">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" style="gap:12px">

      <!-- Left: summary + actions -->
      <div fxFlex="65">
        <div class="alignment" fxLayoutAlign.xs="start center">
          <div>
            <h3 style="margin:0">{{ displayPlanName }}</h3>
            <div style="font-size:13px;color:#666">Subscription ID: {{ subscriptionSummary?.subscriptionId ||
              subscriptionSummary?.id || subscriptionSummary?.tenantId || '-' }}</div>
            <div style="font-size:13px;color:#666;margin-top:4px">Start date: {{
              subscriptionSummary?.subscriptionStartDate || subscriptionSummary?.validFrom | date:'MMM dd, yyyy' }}
            </div>
            <div style="font-size:13px;color:#666;margin-top:4px">End date: {{ subscriptionSummary?.renewalDate ||
              subscriptionSummary?.renewaldate || subscriptionSummary?.renewal_date || subscriptionSummary?.validTill |
              date:'MMM dd, yyyy' }}</div>
          </div>
          <div fxLayoutAlign.xs="start center" fxLayoutGap="8px" style="margin-left:12px ;flex-wrap:wrap">
            <!-- If subscription is expired, show only Renew button -->
            <ng-container *ngIf="subscriptionExpired">
              <div
                style="width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;padding:8px">
                <div style="font-weight:700;color:#d32f2f">Subscription expired</div>
                <button class="mobileview" mat-raised-button color="primary" (click)="onRenew()"
                  style="min-width:160px">{{ buttonLabel || 'Renew Now' }}</button>
              </div>
            </ng-container>

            <!-- Normal actions for active subscriptions -->
            <ng-container *ngIf="!subscriptionExpired" style="gap:8px">
              <button class="mobileview" mat-stroked-button color="primary" (click)="onChangePlan()">Change
                plan</button>
              <button class="mobileview" *ngIf="!isFreePlan && !isUnlimitedPlan && !subscriptionExpired"
                mat-stroked-button (click)="onAddUsers()">Add users</button>
              <!-- #sym:addUser: show extra add-users button during upgrade flow -->
              <button class="mobileview"
                *ngIf="upgradePlantype && (subscriptionSummary?.subscriptionActive || hasActiveSubscription)"
                mat-stroked-button color="accent" (click)="onAddUsers()">Add users (upgrade)</button>
              <button class="mobileview" mat-stroked-button (click)="onManageSubscription()">Manage
                subscription</button>
              <button class="mobileview" mat-stroked-button color="accent" (click)="onAddOns()">Add-ons</button>
              <button class="mobileview" *ngIf="!canRenew" mat-raised-button color="primary" (click)="onRenew()"
                style="margin-left:8px">{{ buttonLabel || 'Renew Now' }}</button>
              <!-- Billing type quick toggle -->
              <div *ngIf="showPaymentCylce" style="display:flex;gap:6px;align-items:center;margin-left:8px">
                <button class="mobileview" mat-button
                  [color]="(subscriptionSummary?.billingCycle || '') === 'monthly' ? 'accent' : ''"
                  (click)="onChangeBillingType('monthly')">Monthly</button>
                <button class="mobileview" mat-button
                  [color]="(subscriptionSummary?.billingCycle || '') === 'annually' ? 'accent' : ''"
                  (click)="onChangeBillingType('annually')">Annually</button>
              </div>
            </ng-container>
          </div>
        </div>

      </div>

      <!-- Right: next payment and quick actions (hidden for trial accounts) -->
      <div fxFlex="35" style="display:flex;justify-content:flex-end">
        <ng-container *ngIf="!subscriptionExpired && !isTrial">
          <div style="min-width:180px;background:#fff;
            border-radius:8px;padding:12px;box-shadow:0 1px 4px rgba(0,0,0,0.06);text-align:center">
            <div style="font-size:12px;color:#666">Last payment</div>
            <div style="font-weight:700;font-size:14px;margin-top:6px">
              <ng-container *ngIf="!subscriptionExpired">{{ latestPaymentSubscription?.content?.[0]?.paymentDate |
                date:'MMM dd, yyyy'}}</ng-container>
            </div>
            <div style="font-size:16px;color:#0b74de;margin-top:8px">
              <ng-container *ngIf="!subscriptionExpired">{{ currencySymbol }}{{
                latestPaymentSubscription?.content?.[0]?.amount }}</ng-container>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isTrial">
          <div
            style="min-width:180px;background:#fff;border-radius:8px;padding:12px;box-shadow:0 1px 4px rgba(0,0,0,0.06);text-align:center">
            <div style="font-size:12px;color:#888;margin-bottom:6px">Trial active</div>
            <div style="font-size:13px;color:#555">{{ subscriptionSummary?.trialDaysRemaining ?? 0 }} days remaining
            </div>
          </div>
        </ng-container>
      </div>

    </div>

    <!-- Secondary row: Billing Contact box -->
    <!-- <div style="margin-top:12px;display:flex;gap:12px;flex-wrap:wrap">
        <div style="flex:1;min-width:280px;background:#fff;border-radius:8px;padding:12px;box-shadow:0 1px 4px rgba(0,0,0,0.04)">
            <div style="display:flex;justify-content:space-between;align-items:start">
                <div>
                    <div style="font-size:13px;color:#666">Billing Contact</div>
                        <div style="font-weight:600">{{ subscriptionSummary?.billingContact?.name || subscriptionSummary?.billingName || subscriptionSummary?.billing_name || '-' }}</div>
                        <div style="font-size:13px;color:#666;margin-top:6px">GST/VAT: {{ subscriptionSummary?.billingContact?.gst || subscriptionSummary?.gst || subscriptionSummary?.gst_vat || '-' }}</div>
                </div>
                <div style="font-size:13px;color:#0b74de;cursor:pointer;display:flex;flex-direction:column;align-items:flex-end">
                    <a (click)="onEditBilling()" style="cursor:pointer">Edit billing</a>
                    <a *ngIf="showPaymentOptions" (click)="onEditBilling()" style="cursor:pointer;margin-top:6px;font-size:12px;color:#0b74de">Manage payment options</a>
                </div>
            </div>
        </div>

        <div style="min-width:220px;display:flex;align-items:center;justify-content:center">
          
        </div>
    </div> -->

    <!-- Line items table (hidden when subscription expired) -->
    <ng-container *ngIf="!subscriptionExpired">
      <div style="margin-top:12px;background:#fff;border-radius:8px;padding:8px;box-shadow:0 1px 4px rgba(0,0,0,0.04)">
        <table style="width:100%;border-collapse:collapse">
          <thead>
            <tr style="text-align:left;border-bottom:1px solid #eee">
              <th style="padding:8px">Item</th>
              <th style="padding:8px">Unit Price</th>
              <th style="padding:8px">Units</th>
              <th style="padding:8px;text-align:right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="padding:8px">{{ displayPlanName }}</td>
              <td style="padding:8px">{{ currencySymbol }}{{ fallbackCycleUnitPrice }}</td>
              <td *ngIf="isUnlimitedPlan" style="padding:8px">Unlimited</td>
              <td *ngIf="!isUnlimitedPlan" style="padding:8px">{{ displayUsers }} users</td>
              <td style="padding:8px;text-align:right">{{ currencySymbol }}{{ currentSubtotal }}</td>
            </tr>
            <tr *ngIf="currentGstAmount > 0">
              <td colspan="3" style="padding:8px">GST (18%)</td>
              <td style="padding:8px;text-align:right">{{ currencySymbol }}{{ currentGstAmount | number:'1.2-2' }}</td>
            </tr>
            <tr style="border-top:1px solid #eee">
              <td colspan="3" style="padding:8px;font-weight:700">Grand Total</td>
              <td style="padding:8px;text-align:right;font-weight:700">{{ currencySymbol }}{{ currentGrandTotal }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!-- ================================================================= -->
    <!-- Add-on Renewal Section (only when not expired)                    -->
    <!-- ================================================================= -->
    <ng-container *ngIf="!subscriptionExpired">

      <!-- Loading skeleton -->
      <div *ngIf="renewalPreviewLoading"
        style="margin-top:12px;padding:12px;background:#f8fafc;border-radius:8px;color:#7b8aa3;font-size:13px">
        Loading add-on details...
      </div>

      <!-- Addon lines -->
      <ng-container
        *ngIf="!renewalPreviewLoading && (addonLines.length > 0 || excludedAddonLines.length > 0 || newAddonSelections.length > 0)">
        <div
          style="margin-top:16px;background:#fff;border-radius:8px;padding:12px;box-shadow:0 1px 4px rgba(0,0,0,0.06)">
          <div style="font-weight:600;font-size:14px;margin-bottom:10px;color:#333">Current Add-ons</div>

          <!-- Active addons (renew checkbox) -->
          <div *ngFor="let addon of addonLines"
            style="display:flex;align-items:center;justify-content:space-between;padding:8px 0;border-bottom:1px solid #f0f0f0;flex-wrap:wrap;gap:8px">
            <div style="display:flex;align-items:center;gap:10px;flex:1;min-width:220px">
              <!-- <mat-checkbox
                [checked]="addon.includeInRenewal"
                (change)="onAddonIncludeChange(addon, $event.checked)"
                color="primary">
              </mat-checkbox> -->
              <div>
                <div style="font-weight:500;font-size:13px">{{ addon.addonName }}</div>
                <div style="font-size:12px;color:#777">
                  {{ addon.quantity }} {{ addon.unitLabel || 'units' }}
                  &nbsp;·&nbsp;
                  Expires: {{ addon.currentEndDate | date:'MMM dd, yyyy' }}
                </div>
              </div>
            </div>
            <div style="text-align:right;min-width:120px">
              <div style="font-size:13px;color:#555">{{ currencySymbol }}{{ addon.payableAmount | number:'1.2-2' }} +
                GST</div>
              <div style="font-weight:600;font-size:14px;color:#0b74de">{{ currencySymbol }}{{ addon.finalPayable |
                number:'1.2-2' }}</div>
              <div style="font-size:11px;color:#aaa">Next cycle ends: {{ addon.projectedEndDate | date:'MMM dd, yyyy' }}
              </div>
            </div>
          </div>

          <!-- Excluded addons (informational) -->
          <div *ngIf="excludedAddonLines.length > 0" style="margin-top:10px">
            <div style="font-size:12px;color:#888;margin-bottom:6px">Excluded from renewal:</div>
            <div *ngFor="let addon of excludedAddonLines"
              style="display:flex;align-items:center;justify-content:space-between;padding:6px 0;opacity:0.6;font-size:12px;color:#555">
              <span>{{ addon.addonName }} ({{ addon.quantity }} {{ addon.unitLabel || 'units' }})</span>
              <span>Will not be renewed</span>
            </div>
          </div>
        </div>

        <!-- new add-ons via modal (button in header) -->

        <!-- Renewal Summary -->
        <div
          style="margin-top:12px;background:#f0f7ff;border-radius:8px;padding:12px;box-shadow:0 1px 4px rgba(0,0,0,0.04)">
          <div style="font-weight:600;font-size:14px;margin-bottom:10px;color:#1565c0">
            {{ canRenew ? 'Renewal Summary' : 'Add-on Purchase Summary' }}
          </div>
          <table style="width:100%;border-collapse:collapse;font-size:13px">
            <tbody>
              <tr *ngIf="canRenew">
                <td style="padding:5px 0;color:#555">Plan renewal (excl. GST)</td>
                <td style="padding:5px 0;text-align:right">{{ currencySymbol }}{{ renewalPlanAmount | number:'1.2-2' }}
                </td>
              </tr>
              <tr *ngIf="addonLines.length > 0 && canRenew">
                <td style="padding:5px 0;color:#555">Add-on renewal (excl. GST)</td>
                <td style="padding:5px 0;text-align:right">{{ currencySymbol }}{{ selectedAddonSubtotal | number:'1.2-2'
                  }}</td>
              </tr>
              <tr *ngIf="newAddonSelections.length > 0">
                <td style="padding:5px 0;color:#1565c0">New add-ons — pro-rated (excl. GST)</td>
                <td style="padding:5px 0;text-align:right;color:#1565c0">{{ currencySymbol }}{{ newAddonSubtotal |
                  number:'1.2-2' }}</td>
              </tr>
              <tr>
                <td style="padding:5px 0;color:#555">GST</td>
                <td style="padding:5px 0;text-align:right">{{ currencySymbol }}{{ ( (canRenew ? renewalPlanGst +
                  selectedAddonGst : 0) + newAddonGst) | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="renewalWalletCredit > 0 && canRenew">
                <td style="padding:5px 0;color:#2e7d32">Wallet credit</td>
                <td style="padding:5px 0;text-align:right;color:#2e7d32">- {{ currencySymbol }}{{ renewalWalletCredit |
                  number:'1.2-2' }}</td>
              </tr>
              <tr [style.border-top]="canRenew ? '2px solid #1565c0' : '1px solid #c5d9f0'">
                <td style="padding:8px 0;font-weight:700;color:#1565c0">{{ canRenew ? 'Final Payable' : 'Total Payable'
                  }}</td>
                <td style="padding:8px 0;text-align:right;font-weight:700;font-size:15px;color:#1565c0">{{
                  currencySymbol }}{{ (canRenew ? renewalFinalPayable : (newAddonSubtotal + newAddonGst)) |
                  number:'1.2-2' }}</td>
              </tr>
            </tbody>
          </table>
          <!-- <div style="margin-top:12px;text-align:right">
            <button mat-raised-button color="primary"
                    (click)="onProceedRenewalWithAddons()">
              Renew Now (Plan + Add-ons)
            </button>
          </div> -->
        </div>
      </ng-container>

    </ng-container>
    <!-- ================================================================= -->

  </div>

</ng-container>

<ng-template #loading>
  <div class="subscription-active-banner"
    style="margin-bottom:12px;padding:12px;border:1px dashed #e6eef8;border-radius:6px;background:#fbfdff;color:#7b8aa3">
    Loading subscription details...
  </div>
</ng-template>

<!-- Add users modal inside child -->
<div *ngIf="addUserModalOpen"
  style="position:fixed;left:0;top:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.4);z-index:2000">
  <div style="width:420px;background:#fff;border-radius:8px;padding:20px;box-shadow:0 6px 24px rgba(0,0,0,0.2)">
    <h3 style="margin-top:0">Add users</h3>
    <p style="color:#555">Select number of additional users to add. Prorated amount shown below.</p>
    <div style="display:flex;gap:8px;align-items:center;margin:12px 0">
      <mat-form-field appearance="outline" style="width:120px">
        <mat-label>Additional users</mat-label>
        <input matInput type="number" min="1" [formControl]="addUserControl" (keydown)="onAddUserKeydown($event)"
          (input)="onAddUserInput($event)" (blur)="onAddUserControlBlur()" />
      </mat-form-field>
      <div style="flex:1">
        <div style="font-size:13px;color:#777">Prorated charge (excl. GST)</div>
        <div style="font-weight:700;font-size:18px">{{ currencySymbol }}{{ addUserCharge || 0 }}</div>
        <div style="font-size:12px;color:#888">GST: {{ currencySymbol }}{{ addUserTax || 0 }} · Total: {{ currencySymbol
          }}{{ (addUserCharge || 0) + (addUserTax || 0) }}</div>
      </div>
    </div>

    <div style="display:flex;justify-content:flex-end;gap:8px;margin-top:16px">
      <button mat-button (click)="addUserModalOpen=false">Cancel</button>
      <button mat-raised-button color="primary" (click)="onProceedToPay()">Proceed to pay</button>
    </div>

    <div *ngIf="addUserCheckoutInProgress" style="margin-top:16px">
      <p style="margin:0 0 8px 0">Complete payment to add users</p>
      <!-- #sym:checkoutSubscription - payment will call subscriptions.checkoutSubscription via onAddUserPayment -->
      <calsoft-payment
        [contact]="{name: subscriptionSummary?.billingName, email: subscriptionSummary?.email, phone: subscriptionSummary?.phone}"
        [partialAmountEnabled]="0" [type]="2" [finalAmount]="(addUserCharge || 0) + (addUserTax || 0)"
        (paymentStatus)="onAddUserPayment($event)"></calsoft-payment>
    </div>

  </div>
</div>

<!-- ================================================================= -->
<!-- Add-ons Picker Modal                                               -->
<!-- ================================================================= -->
<div *ngIf="showAddonModal"
  style="position:fixed;left:0;top:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.45);z-index:2000">
  <div
    style="width:660px;max-width:96vw;max-height:88vh;overflow-y:auto;background:#fff;border-radius:10px;padding:24px;box-shadow:0 8px 32px rgba(0,0,0,0.22)">

    <!-- Header -->
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px">
      <h3 style="margin:0;color:#1565c0">Add-ons</h3>
      <button mat-icon-button (click)="showAddonModal=false"><mat-icon>close</mat-icon></button>
    </div>

    <div *ngIf="availableAddonsLoading" style="padding:16px 0;font-size:13px;color:#7b8aa3">Loading available add-ons...
    </div>
    <div *ngIf="!availableAddonsLoading && availableAddons.length === 0"
      style="padding:16px 0;font-size:13px;color:#888">No additional add-ons available for your subscription.</div>

    <ng-container *ngIf="!availableAddonsLoading && availableAddons.length > 0">

      <!-- PLAN-type addons (max 1) -->
      <ng-container *ngIf="planTypeAddons.length > 0">
        <div style="font-size:12px;color:#1565c0;font-weight:600;margin-bottom:8px">
          Plan Add-ons <span style="font-weight:400;color:#888">(max 1)</span>
        </div>
        <div *ngFor="let addon of planTypeAddons"
          style="display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f0f0f0;flex-wrap:wrap;gap:8px">
          <div style="display:flex;align-items:center;gap:10px;flex:1;min-width:220px">
            <mat-checkbox [checked]="isAddonSelected(addon.addonCode)"
              [disabled]="isPlanAddonDisabledForSelection(addon)" (change)="onToggleNewAddon(addon, $event.checked)"
              color="primary">
            </mat-checkbox>
            <div>
              <div style="font-weight:500;font-size:13px">{{ addon.addonName }}</div>
              <div style="font-size:12px;color:#777">
                {{ currencySymbol }}{{ getCyclePriceForAddon(addon)?.unitPrice ?? '—' }}/{{ addon.unitLabel || 'unit' }}
                &nbsp;·&nbsp;GST {{ getCyclePriceForAddon(addon)?.gstPercentage ?? 18 }}%
                &nbsp;·&nbsp;<span style="color:#1565c0">Pro-rated till end</span>
              </div>
            </div>
          </div>
          <div *ngIf="isAddonSelected(addon.addonCode)" style="text-align:right;min-width:120px">
            <ng-container *ngFor="let sel of newAddonSelections">
              <ng-container *ngIf="sel.addon.addonCode === addon.addonCode">
                <div style="font-size:12px;color:#555">{{ currencySymbol }}{{ sel.proratedSubtotal | number:'1.2-2' }} +
                  GST</div>
                <div style="font-weight:600;font-size:14px;color:#0b74de">{{ currencySymbol }}{{ sel.total |
                  number:'1.2-2' }}</div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <!-- Other addons -->
      <ng-container *ngIf="otherTypeAddons.length > 0">
        <div style="font-size:12px;color:#333;font-weight:600;margin:12px 0 8px">Other Add-ons</div>
        <div *ngFor="let addon of otherTypeAddons"
          style="display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f0f0f0;flex-wrap:wrap;gap:8px">
          <div style="display:flex;align-items:center;gap:10px;flex:1;min-width:220px">
            <mat-checkbox [checked]="isAddonSelected(addon.addonCode)"
              (change)="onToggleNewAddon(addon, $event.checked)" color="primary">
            </mat-checkbox>
            <div>
              <div style="font-weight:500;font-size:13px">{{ addon.addonName }}</div>
              <div style="font-size:12px;color:#777">
                {{ currencySymbol }}{{ getCyclePriceForAddon(addon)?.unitPrice ?? '—' }}/{{ addon.unitLabel || 'unit' }}
                &nbsp;·&nbsp;GST {{ getCyclePriceForAddon(addon)?.gstPercentage ?? 18 }}%
                &nbsp;·&nbsp;<span style="color:#1565c0">Pro-rated till end</span>
              </div>
            </div>
          </div>
          <ng-container *ngIf="isAddonSelected(addon.addonCode)">
            <ng-container *ngFor="let sel of newAddonSelections">
              <ng-container *ngIf="sel.addon.addonCode === addon.addonCode">
                <div style="display:flex;align-items:center;gap:8px">
                  <mat-form-field appearance="outline" style="width:90px;font-size:12px">
                    <mat-label>Qty</mat-label>
                    <input matInput type="number" [min]="addon.minQuantity || 1" [max]="addon.maxQuantity || null"
                      [value]="sel.quantity" (change)="onNewAddonQuantityChange(sel, +$any($event.target).value)" />
                  </mat-form-field>
                  <div style="text-align:right;min-width:100px">
                    <div style="font-size:12px;color:#555">{{ currencySymbol }}{{ sel.proratedSubtotal | number:'1.2-2'
                      }} + GST</div>
                    <div style="font-weight:600;font-size:14px;color:#0b74de">{{ currencySymbol }}{{ sel.total |
                      number:'1.2-2' }}</div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>

    <!-- Selected summary -->
    <div *ngIf="newAddonSelections.length > 0"
      style="margin-top:16px;background:#f0f7ff;border-radius:8px;padding:12px">
      <div style="font-weight:600;font-size:13px;color:#1565c0;margin-bottom:8px">Selected Add-ons</div>
      <div *ngFor="let sel of newAddonSelections"
        style="display:flex;justify-content:space-between;font-size:13px;padding:2px 0">
        <span>{{ sel.addon.addonName }} × {{ sel.quantity }}</span>
        <span style="color:#0b74de">{{ currencySymbol }}{{ sel.total | number:'1.2-2' }}</span>
      </div>
      <div
        style="border-top:1px solid #c5d9f0;margin-top:8px;padding-top:8px;display:flex;justify-content:space-between;font-weight:700;font-size:13px">
        <span>Total (incl. GST)</span>
        <span style="color:#1565c0">{{ currencySymbol }}{{ (newAddonSubtotal + newAddonGst) | number:'1.2-2' }}</span>
      </div>
    </div>

    <!-- Actions -->
    <div style="display:flex;justify-content:flex-end;gap:10px;margin-top:20px">
      <button mat-button (click)="showAddonModal=false;newAddonSelections=[];">Cancel</button>
      <button *ngIf="!subscriptionExpired" mat-raised-button color="primary"
        (click)="onProceedRenewalWithAddons(true); showAddonModal=false" [disabled]="newAddonSelections.length === 0">
        Add Add-on Only
      </button>

    </div>

  </div>
</div>